import { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import IncTextField from '../fields/inc-text-field/inc-text-field.component';
import AutocompleteBase from '../fields/autocomplete-field/autocomplete-base/autocomplete-base.component';
import { Typography } from '@mui/material';
import { GetEnvironmentsResult } from 'api/qa-env/qa-env.types';
import { getEnvSessionData } from 'components/change-env/change-env.utils';
import { ENV_PRESETS } from './change-env-form.constants';

type ChangeEnvFormTypes = {
  environments: GetEnvironmentsResult;
};

const ChangeEnvForm = ({ environments }: ChangeEnvFormTypes) => {
  const { t } = useTranslation();
  const [autocompleteValue, setAutocompleteValue] = useState(null);
  const { setValue } = useFormContext();

  useEffect(() => {
    const savedApiUrl = getEnvSessionData()?.REACT_APP_ADMIN_API_URL;
    setAutocompleteValue(
      environments.find(
        env => (ENV_PRESETS[env.id]?.apiUrl ?? env.id) === savedApiUrl,
      )?.id ?? environments[0].id,
    );
  }, [environments]);

  const handleChange = (_e, value) => {
    setAutocompleteValue(value.id);

    const preset = ENV_PRESETS[value.id];
    setValue('REACT_APP_ADMIN_API_URL', preset ? preset.apiUrl : value.id);
    setValue(
      'REACT_APP_DEFAULT_CLIENT',
      preset ? preset.clientAlias : 'palmlaneqa',
    );
  };

  return (
    <>
      <Typography data-testid="UtilityDrawer.Typography">
        {t('drawer.changeEnvDrawer.description')}
      </Typography>
      <AutocompleteBase
        options={environments}
        value={autocompleteValue}
        data-testid="ChangeEnvForm.AutocompleteBase"
        onChange={handleChange}
        disableClearable
        TextFieldProps={{
          label: t('drawer.changeEnvDrawer.selector.label'),
        }}
      />
      <IncTextField
        name="REACT_APP_ADMIN_API_URL"
        label={t('forms.fields.baseurl.label')}
        data-testid="ChangeEnvForm.IncTextField.Baseurl"
        disabled={autocompleteValue !== 'custom'}
      />
      <IncTextField
        name="REACT_APP_DEFAULT_CLIENT"
        label={t('forms.fields.clientAlias.label')}
        data-testid="ChangeEnvForm.IncTextField.ClientAlias"
      />
    </>
  );
};

export default ChangeEnvForm;
